let language = {
    "LBL_HOME":"Home",
    "LBL_ADD_INVITEE": "Add Invitee",
    "LBL_VIEW_INVITEE": "View Invitee",
    "LBL_PI_NAME": "PI Name",
    "LBL_PI_MOBILE": "PI Mobile",
    "LBL_PI_PROFESSIONAL": "PI Professional",
    "LBL_CREATED_BY": "Created By",
    "LBL_PARENT_ID": "Parent ID",
    "LBL_PARENT_TYPE": "Parent Type",
    "LBL_DESCRIPTION":"Description",
    "LBL_CREATE_DATE":"Date Created",
    "LBL_ENTERED":"Date Entered",
    "LBL_MODIFIED_DATE":"Date Modified",
    "LBL_DOWNLOAD_ONE":"Download 1",
    "LBL_DOWNLOAD_TWO":"Download 2",
    "LBL_EDIT":"Edit",
    "LBL_DELETE":"Delete",
    "LBL_OPPORTUNITY_TITLE":"Opportunity Title",
}

export default language;